import { render, staticRenderFns } from "./Extruder.vue?vue&type=template&id=0387668c&scoped=true"
import script from "./Extruder.vue?vue&type=script&lang=js"
export * from "./Extruder.vue?vue&type=script&lang=js"
import style0 from "./Extruder.vue?vue&type=style&index=0&id=0387668c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0387668c",
  null
  
)

export default component.exports